export default (sex) => {
  if (sex == "M") {
    return "男"
  }
  return "女"
}



// WEBPACK FOOTER //
// ./src/utils/getSex.js